<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div class="table-container" *ngIf="documentData.module =='DOCS'">
  <div id="header-container" class="d-flex justify-content-end gap-3 mt-1 mb-3">
    <div class="">
      <div class="search-container">
        <input type="text" class="form-control search_input" style="font-size: 13px;" placeholder="Search"
          [(ngModel)]="searchValue">
      </div>
    </div>

    <div class="">
      <div class="d-flex gap-2 action-buttons-container">
        <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="refreshGrid()"
          (keydown.enter)="refreshGrid()" matTooltip="Refresh Grid">
          <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
          <span class="reload_text">Reload</span>
        </div>

      </div>
    </div>
  </div>

  <table class="dynamic-table-container documentTable">
    <th style="min-width: 60px; text-align: center;">

    </th>
    <th *ngFor="let column of columnList"
      [ngStyle]="{'min-width': column.width, 'max-width': column.width, 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
        <span>{{column.column}}</span>
        <div class="d-flex gap-2 align-items-center">
          <div>
            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
          </div>
        </div>

      </div>
    </th>
    <th  class="sticky-col first-col"></th>
    <!-- search input row is added -->
    <tr *ngFor="let withdraw of withdrawalList | searchFilter : searchValue; let idx = index;">
      <td style="width: 60px; text-align: center;"
        [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
        <div style="display: flex;">
          <div [ngClass]="withdraw.childCheckBoxs ?'static_icon':'hover-menu-icons'">
            <i class="fa-solid fa-ellipsis-vertical"></i>
          </div>
          <div>
            <input type="checkbox" style="zoom: 1.2;" [checked]="childCheckBoxs"
              (change)="dataGridChildCheckBoxChecked($event, withdraw, idx)">
          </div>
        </div>
      </td>
      <td class="grid-row-container" style="text-align: center;overflow: hidden;text-overflow: 'ellipsis';
          white-space: 'nowrap'"><a href="" (click)="openDetailedpopup(withdraw,$event)">{{withdraw.withdrawalId}}</a>
      </td>

      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
            white-space: 'nowrap'"><span>{{withdraw.reason}}</span></td>
      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
             white-space: 'nowrap'"><span>{{withdraw.crDetails}}</span></td>
      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
             white-space: 'nowrap'"><span>{{withdraw.status}}</span></td>
      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
             white-space: 'nowrap'"><span>{{withdraw.createdOn | date:uiDateTimeFormat | uppercase}}</span></td>
      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
             white-space: 'nowrap'"><span>{{withdraw.createdByUser}}</span></td>
      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
             white-space: 'nowrap'"><span>{{withdraw.updatedOn | date:uiDateTimeFormat | uppercase}}</span></td>
      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
             white-space: 'nowrap'"><span>{{withdraw.updatedByUser}}</span></td>
      <td class="sticky-col first-col" *ngIf="documentData.saveButtonForDocument">
        <div class="action-icons">
          <i class="fa-solid fa-pencil" matTooltip="Edit Withdrawn" style="margin-left: 5px;"
            (click)="editWithdrawFunc(withdraw,$event)" (keydown.enter)="editWithdrawFunc(withdraw,$event)"></i>

        </div>
      </td>
    </tr>
  </table>
  <div class="d-flex justify-content-center">
    <div class="width-cheat small paginationCell">
      <div class="d-flex align-items-center gap-3">
        <div class="pagination_text mt-3">
          {{ showingRowsText }}
          1-{{ perPage }} of {{ collectionSize | number }}
        </div>
        <div>
          <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
            [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
            [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
          </ngb-pagination>
        </div>
        <div ngbDropdown class="mt-3">
          <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1" ngbDropdownToggle>
            {{ perPage }}
            <i class="ms-1 fa-solid fa-chevron-down"></i>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <button ngbDropdownItem (click)="paginationCall(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall(50)">50</button>
          </div>
          per page
        </div>
      </div>
    </div>
  </div>

</div>
<div class="menu-container" *ngIf="documentData.module == 'MYTASK'">
  <div class="row menu-row-container" style="height: 25px;">
    <div class="col-sm-6 gridName-container">
      <span class="gridName">{{submodule}} - {{status}}</span>
    </div>
  </div>
  <hr>
</div>
<div class="table-container" *ngIf="documentData.module == 'MYTASK'">

  <div class="d-flex justify-content-end gap-3 mt-1 mb-3 header-container">
    <div class="">
      <div class="search-container">
        <input type="text" class="form-control search_input" style="font-size: 13px;" placeholder="Search"
          [(ngModel)]="searchValue">
      </div>
    </div>
  </div>

  <table class="dynamic-table-container documentTable">
    <th style="min-width: 60px; text-align: center;">
    </th>
    <th *ngFor="let column of columnList"
      [ngStyle]="{'min-width': column.width, 'max-width': column.width, 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
        <span>{{column.column}}</span>
        <div class="d-flex gap-2 align-items-center">
          <div>
            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
          </div>
        </div>
      </div>
    </th>

    <th class="sticky-col first-col menu"></th>
    <!-- search input row is added -->
    <tr *ngFor="let task of withdrawalList | searchFilter : searchValue; let idx = index;">
      <td style="width: 60px; text-align: center;"
        [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
        <div style="display: flex;">
          <div [ngClass]="task.childCheckBoxs ?'static_icon':'hover-menu-icons'">
            <i class="fa-solid fa-ellipsis-vertical"></i>
          </div>
          <div>
            <input type="checkbox" style="zoom: 1.2;" [checked]="childCheckBoxs"
              (change)="dataGridChildCheckBoxChecked($event, task, idx)">
          </div>
        </div>
      </td>
      <td class="grid-row-container" style="text-align: center;overflow: hidden;text-overflow: 'ellipsis';
          white-space: 'nowrap'"><a style="color: blue !important;text-decoration: underline;cursor: pointer;"><span
            (click)="openDetailedpopup(task,$event)"
            (keydown.enter)="openDetailedpopup(task,$event)">{{task.taskNo}}</span></a></td>
      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
            white-space: 'nowrap'"><span>{{task.taskName}}</span></td>
      <td *ngIf="documentData.level == 3" class="grid-row-container" style="text-align: center;overflow: hidden;text-overflow: 'ellipsis';
           white-space: 'nowrap'"><span>{{task.subTaskName}}</span></td>
      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
           white-space: 'nowrap'"><span>{{task.taskOwnerUserName}}</span></td>
      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
            white-space: 'nowrap'"><span>{{task.requesterUserName}}</span></td>
      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
             white-space: 'nowrap'"><span>{{task.actionRequestedOn | date:uiDateTimeFormat | uppercase}}</span></td>
      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
             white-space: 'nowrap'"><span>{{task.pendingWithUserNames}}</span></td>
      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
              white-space: 'nowrap'"><span>{{task.dueOn | date:uiDateTimeFormat | uppercase}}</span></td>
    </tr>
  </table>
  <div class="d-flex justify-content-center">
    <div class="width-cheat small paginationCell">
      <div class="d-flex align-items-center gap-3">
        <div class="pagination_text mt-3">
          {{ showingRowsText }}
          1-{{ perPage }} of {{ collectionSize | number }}
        </div>
        <div>
          <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
            [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
            [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
          </ngb-pagination>
        </div>
        <div ngbDropdown class="mt-3">
          <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text dropdownBasic1" ngbDropdownToggle>
            {{ perPage }}
            <i class="ms-1 fa-solid fa-chevron-down"></i>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <button ngbDropdownItem (click)="paginationCall(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall(50)">50</button>
          </div>
          per page
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #addOrEditWithdrawPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>

    <div mat-dialog-title>
      <label for="pop" class="popupTitle"> {{title}}</label>
      <label for="popup" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div id="filed-container" class="form-continer">
      <div>

        <div class="row">
          <div class="col-md-3"><label for="email">Reason</label><span class="mandatory-symbol">*</span></div>
          <div class="col-md-9"> <textarea id="deleteTextarea" type="text" class="input-filed-textarea" rows="4"
              cols="50" [(ngModel)]="withdrawData.reason"></textarea>
          </div>
        </div>
        <div class="row" *ngIf="withdrawData.crDetails != null">
          <div class="col-md-3"><label for="email">CR</label></div>
          <div class="col-md-9 row-search-container">
            <input id="cr" class="form-control" type="text" placeholder="Search" [(ngModel)]="withdrawData.crDetails"
              (click)="searchCrFunction()" readonly style="cursor: pointer;">
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="addOrUpdateWithdraw(withdrawData)" (keydown.enter)="addOrUpdateWithdraw(withdrawData)"
        *ngIf="!visibleEditButton">
        <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
        <span class="reload_text text-white">Add New</span>
      </div>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="addOrUpdateWithdraw(withdrawData)" (keydown.enter)="addOrUpdateWithdraw(withdrawData)"
        *ngIf="visibleEditButton">
        <i class="fas fa-user-edit" style="font-size: 18px;color: white;"></i>
        <span class="reload_text text-white">Update</span>
      </div>
      <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>
<ng-template #deleteWithdrawPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <h2 mat-dialog-title>{{title }}</h2>
  <div style="margin: 15px 15px;">
    Are you sure you want to delete this record?
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="deleteButton" (click)="deleteFunction()">
        <i class="fa fa-trash"></i> Delete
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelDeleteFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>
<ng-template #withdrawDetailPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelExtensionDetailFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>

    <div mat-dialog-title>
      <label for="pop" class="popupTitle">Withdrawn</label>
      <label for="popup" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 8px;" class="myTrainingLeftPlace">
      <div class="row">
        <div class="col-md-12">
          <div class="pull-right" *ngFor="let button of buttonLabels" style="margin-right: 1%;">
            <span class="button-continer" style="width:auto; float: left;">

              <button *ngIf="button != 'Cancel'" mat-stroked-button class="addButton"
                (click)="dynamicButtonClick(button)">{{button}}</button>
            </span>
          </div>

        </div>
      </div>
      <div class="row" *ngIf="documentData.module == 'MYTASK'">
        <div class="col-md-12" style="padding-left: 0px;padding-right: 0px;">
          <label for="no"> Document No</label>:&nbsp;{{documentData.documentNo}}
        </div>
        <div class="col-md-12" style="padding-left: 0px;padding-right: 0px;">
          <label for="name"> Document Name</label>:&nbsp;{{documentData.documentName}}
        </div>
      </div>
      <div class="row" *ngIf="instructions !=null">
        <p style="text-align: right;"><i>{{instructions}}</i></p>
      </div>
      <div class="row">
        <div class="col-md-12" style="padding-left: 0px;padding-right: 0px;">
          <h4>Withdrawal Details ({{withdrawData.status}})</h4>
          <hr>
        </div>
      </div>
      <div class="table-container">
        <div id="form-field-container" class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-8">
                <div><label for="version">Reason</label></div>
                <textarea rows="2" class="input-filed-textarea" type="text" [(ngModel)]="withdrawData.reason"
                  disabled></textarea>
              </div>
              <div class="col-md-4" *ngIf="withdrawData.crDetails != null">
                <div><label for="version">CR</label></div>
                <div class=" row-search-container">
                  <input id="crDetails" class="form-control" type="text" placeholder="Search"
                    [(ngModel)]="withdrawData.crDetails" disabled>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <app-stage-user [data]="withdrawData"></app-stage-user>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #confirmWithReasonPopup>
  <h2 mat-dialog-title>{{title }}</h2>
  <div style="margin: 15px 15px;">
    <div>
      <div class="row">
        <div class="col-md-12">
          <div><label for="reason"> Reason</label><span class="mandatory-symbol">*</span></div>
          <textarea id="reason" rows="4" class="textarea-filed-continers" type="text" [(ngModel)]="reason"></textarea>
          <div id="reason-val-icon" class="field-icon-container"></div>
          <span id="reason-required-msg">Please enter reason</span>
        </div>
      </div>

    </div>
    <br>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="confirmWithReasonFunc()">
        {{buttonLabel}}
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelFunc()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #confirmPopup>
  <h2 mat-dialog-title>{{title }}</h2>
  <div style="margin: 15px 15px;">
    <div class="form-continer">
      <div class="row">
        <div class="col-md-12">
          Are you sure you want to {{buttonLabel}}?
        </div>
      </div>
      <br>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="confirmOkFunc()">
        {{buttonLabel}}
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelConfirmFunc()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #confirmWithDataPopup>
  <h2 mat-dialog-title>{{buttonLabel }}</h2>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <div style="padding: 2%;">
    <div class="row">
      <div class="col-md-6" style="border-right: 1px solid black;">
        <div><label style="margin-left: 20%;font-weight: 600;" for="status">Action</label><span
            class="mandatory-symbol">*</span></div>
        <mat-radio-group id="status" class="tp-radio-group" [(ngModel)]="selectedStatus"
          style="display: flex;flex-direction: column;">
          <mat-radio-button class="tp-radio-button" *ngFor="let status of statusList" [value]="status.codelistCode"
            (change)="onStatusSelect(status.codelistCode)">
            {{status.codelistName}}
          </mat-radio-button>
        </mat-radio-group>
        <span style="margin-left: 25%;" id="status-required-msg">Please select status</span>
      </div>
      <div class="col-md-6" *ngIf="isEsignRequired" style="margin-top: 2%;">
        <div class="row" *ngIf="isEsignRequired">
          <div><label for="username ">User Name</label><span class="mandatory-symbol">*</span>
          </div>
          <div> <input id="username" style="height: 80% !important;" class="input-filed-continers" type="text"
              [(ngModel)]="displayUserName" disabled>
          </div>
        </div>
        <div class="row" *ngIf="(isEsignRequired && !isAdenabled)">
          <div><label for="pass ">Password</label><span class="mandatory-symbol">*</span></div>
          <div> <input id="pass" style="height: 80% !important;" class="input-filed-continers"
              [type]="changetypeAddAndEditPassword ? 'password' : 'text'" [(ngModel)]="password" noCopyPaste>
            <span class="eyeicon-container eye-color" (click)="showPassword()" (keydown.enter)="showPassword()">
              <i
                [class]="changetypeAddAndEditPassword ? 'fas fa-eye-slash' : 'fa fa-fw fa-eye field-icon toggle-password'"></i>
            </span>
          </div>
          <span style="margin-left: 25%;" id="pass-required-msg">Please enter password</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div><label for="comment">Comments</label></div>
      <div> <textarea rows="4" id="comment" class="textarea-filed-continers" type="text"
          [(ngModel)]="comments"></textarea>
      </div>
    </div>

    <div class="row" *ngIf="isShowRejectReason" style="width: 60%;margin-bottom: 1%;">
      <div><label for="rejectReason">Reject Reason</label><span class="mandatory-symbol">*</span></div>
      <div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedRejectReason" id="rejectReason"
          (closed)="rejectReasonSearchText=''" (click)="focusSearch('focus-reject-reason-search')"
          (keydown.enter)="focusSearch('focus-reject-reason-search')">
          <input type="search" id="focus-reject-reason-search" class="dropdownsearchstyle"
            [(ngModel)]="rejectReasonSearchText" matInput placeholder="search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onRejectReasonSelect($event,null)">Un-select</mat-option>
          <mat-option *ngFor="let item of rejectReasonDropdown | assessmentSearch : rejectReasonSearchText"
            [value]="item.valueExp" (onSelectionChange)="onRejectReasonSelect($event,item)">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>

      </div>
      <span id="rejectReason-required-msg">Please select reject reason</span>
    </div>

    <div class="row" *ngIf="isReasonSignReqd" style="width: 60%;margin-bottom: 1%;">
      <div><label for="reasonForSignature">Reason for Signature</label><span class="mandatory-symbol">*</span></div>
      <div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedReason" (closed)="reasonSearchText=''"
          id="reasonForSignature" (click)="focusSearch('focus-reason-search')"
          (keydown.enter)="focusSearch('focus-reason-search')">
          <input type="search" id="focus-reason-search" class="dropdownsearchstyle" [(ngModel)]="reasonSearchText"
            matInput placeholder="search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onReasonSelect($event,null)">Un-select</mat-option>
          <mat-option *ngFor="let item of reasonDropdown | assessmentSearch : reasonSearchText" [value]="item.valueExp"
            (onSelectionChange)="onReasonSelect($event,item)">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>

      </div>
      <span id="reasonForSignature-required-msg">Please select reason for
        signature</span>
    </div>

    <div class="row">
      <div><label for="comment">Document</label></div>
      <div>
        <input type="file" class="file-input" (change)="onConfirmFileSelected($event)" #fileUpload>
      </div>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="confirmWithDataFunc()">
      {{buttonLabel}}
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelConfirmWithDataFunc()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #searchCr>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelCrFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">Search CR</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class=" filed-container form-continer">
    <div class="row">
      <div class="col-md-8 group-dropdown-container">
        <label for="email">Group</label><span class="mandatory-symbol">*</span>
        <div class="col-sm-6 group-dropdown-align">
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedCrGroup" (closed)="groupSearchText=''"
            (click)="focusSearch('focus-group-search')" (keydown.enter)="focusSearch('focus-group-search')">
            <input type="search" id="focus-group-search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null"
              (onSelectionChange)="onGroupValueSelect($event,null)">Un-select</mat-option>
            <mat-option *ngFor="let item of groupValueDropdown | assessmentSearch : groupSearchText"
              [value]="item.valueExp" (onSelectionChange)="onGroupValueSelect($event,item)">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>

        </div>

      </div>
    </div>
    <div class="row text-center">
      <div class="group-dropdown-align">
        <div class="search-button-continer">
          <button mat-stroked-button class="searchButton searchButton1" (click)="seachCrForDocumentsFunc()">
            <i class="fa-solid fa-magnifying-glass"></i> Search
          </button>
          <button mat-stroked-button class="cancelButton resetButton" (click)="gridResetFunction()">
            <i class="fa fa-repeat"></i> Reset
          </button>
        </div>
      </div>
    </div>
    <div class="table-container" *ngIf="isShowSearchedCrGrid">
      <table class="search-manager-table-container">
        <th style="min-width: 80px; text-align: center;">

        </th>
        <th> <span>Cr ID</span> <span class="fa-solid fa-filter multi-filter-container"></span> </th>
        <th> <span>Description</span> <span class="fa-solid fa-filter multi-filter-container"></span> </th>
        <th> <span>Status</span> <span class="fa-solid fa-filter multi-filter-container"></span> </th>
        <th> <span>Initiator</span> <span class="fa-solid fa-filter multi-filter-container"></span> </th>
        <th> <span>Owner</span> <span class="fa-solid fa-filter multi-filter-container"></span> </th>
        <th> <span>QA</span> <span class="fa-solid fa-filter multi-filter-container"></span> </th>
        <th> <span>Business Area</span> <span class="fa-solid fa-filter multi-filter-container"></span> </th>
        <th  class="sticky-col first-col"></th>
        <tr class="data-row-container" *ngFor="let cr of searchedCrList; let idx = index;">
          <td style="min-width: 80px; text-align: center;">
            <div style="display: flex;">
              <div [ngClass]="cr.searchCrChildCheckBoxs ?'static_icon':'hover-menu-icons'">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div style="margin-left: 5px;">
                <input id="selectedUserCheckBox" type="checkbox" style="zoom: 1.2;"
                  [checked]="cr.searchCrChildCheckBoxs" (change)="searchCrChildCheckBoxChecked($event, cr, idx)">
              </div>
            </div>
          </td>
          <td class="row-data">{{ cr.crId }}</td>
          <td class="row-data">{{ cr.shortDescription }}</td>
          <td class="row-data">{{ cr.status }}</td>
          <td class="row-data">{{ cr.initiatedByUserName }}</td>
          <td class="row-data">{{ cr.ownerUserName }}</td>
          <td class="row-data">{{ cr.qaUserName }}</td>
          <td class="row-data">{{ cr.coreBusinessAreaName }}</td>
        </tr>
      </table>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="addCrFunction()">
      <i class="fas fa-check"></i> Add
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelCrFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>